/** @file Default capacity of an overlay chunk (createOverlayChunk, and overlayOutputBytes counts by it). */

/** Vertices per chunk (Uint16 indices: at most 65,535), indices per vertex of room, draws per chunk. */
export const OVERLAY_CHUNK_DEFAULTS = { vertices: 16384, indicesPerVertex: 3, draws: 64 } as const;
